import React from "react";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import ImageListItemBar from "@mui/material/ImageListItemBar";
import {useLightbox} from "./useLightbox";

export default function GalleryWoven({data}) {
    const {handleImageClick, LightboxComponent} = useLightbox(data);

    return (
        <>
            <ImageList className={"gallery woven"} variant="woven" cols={3} gap={8}>
                {data.map((item, idx) => (
                    <ImageListItem key={idx} className={"gallery-item-wrapper"} onClick={() => handleImageClick(idx)}>
                        <img
                            className={"skeleton"}
                            src={item?.imagePath}
                            alt={item?.title}
                            style={{objectPosition: item?.position}}
                            loading="lazy"
                        />
                        <ImageListItemBar className={"title-bar"} title={item?.title} />
                    </ImageListItem>
                ))}
            </ImageList>
            <LightboxComponent />
        </>
    );
}
